import { Module } from 'vuex';
import state from '@/modules/collaborators/store/collaborators.state';
import mutations from '@/modules/collaborators/store/collaborators.mutation';
import actions from '@/modules/collaborators/store/collaborators.action';
import getters from '@/modules/collaborators/store/collaborators.getter';


export interface ICollaboratorsState {
    listUserInvite: [];
    listHistoriesCollaborators: [];
}

export const collaborators: Module<ICollaboratorsState, any> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};


